// Use this pattern:
export const NativeTokenTypes = {
    ERC20: 'ERC20', // default; should be used for fungible tokens eg. credit tokens; There should be only one active ERC20 token per programme
    ERC1155: 'ERC1155',
    ERC721: 'ERC721'
};
//# sourceMappingURL=native-token.type.js.map